import ThemeOne from '../lib/layout-horizontal/AppLayout';
import SectionHeader from '../lib/layout-horizontal/SectionHeader';
import BlockTabsPresentation from '../lib/layout-horizontal/BlockTabsPresentation';
import SectionLayout from '../lib/layout-horizontal/SectionLayout';
import BlockLayout from '../lib/layout-horizontal/BlockLayout';
import Header from '../lib/components/Header';
import VideoCard from '../lib/components/Video/VideoCard';
import VideoCardTwo from '../lib/components/Video/VideoCardTwo';
import VideoCardThree from '../lib/components/Video/VideoCardThree';
import VideoCardFour from '../lib/components/Video/VideoCardFour';
import ImageText from '../lib/components/Feature/ImageText';
import Category from '../lib/components/Category/Category';
import CoverCategory from '../lib/components/CoverCategory/CoverCategory';
import Html from '../lib/components/RichText/Html';
import Text from '../lib/components/Text/Text';
import SectionTitle from '../lib/components/Title';
import BlockTitle from '../lib/components/Title/TitleSecondary';
import VideoBanner from "../lib/components/VideoBanner";
import HeroImage from "../lib/components/HeroImage";
import VideoGrid from "../lib/components/VideoGrid";
import VideoSingle from "./components/VideoSingle";
import Promotions from '../lib/components/Promotions';
import Faq from '../lib/components/Faq';
import FaqLayout from '../lib/components/Faq/FaqLayout';
import Options from '../lib/config/vuetify.options';

//@todo: !IMPORTANT: Use the index on each folder under components to register components info to be autloaded
// instead of being loaded manually.

//Pages
import DetailMovie from '../lib/pages/detail-movie';

//Fix footer
import FooterWithDeco from "./components/Footer/FooterWithDeco";
import FooterMain from './components/Footer/Footer'
import FooterMobile from './components/Footer/FooterMobile'

import Styles from "@fremcast/section/mixins/styles";

export { Options };

export default {
  // called by Vue.use(FirstPlugin)
  install(Vue, options) {

    const vuetify = options.vuetify;

    //const vuetify = new Vuetify(Options);

    const Ctor = Vue.extend(Object.assign(options.vuetify, ThemeOne))
    const Ctor2 = Vue.extend(Object.assign({ vuetify }, Header))

    //const initVuetify = options.InitVuetify;

    /*
    Vue.use(initVuetify,{
      components: {
        // the components which Toast.vue used
        VIcon,
        VSnackbar,
        VSkeletonLoader
      }
    });
    */

    Vue.mixin({
      props: {
        blockProperty: Object,
        blockField: Object
      },
      mixins: [
        Styles
      ]
    });


    Vue.component('theme-one', Ctor);
    Vue.component('main-header', Header);
    Vue.component('section-header', SectionHeader);
    Vue.component('section-layout', SectionLayout);
    Vue.component('block-layout', BlockLayout);
    Vue.component('BlockTabsPresentationStyles', BlockTabsPresentation);
    Vue.component('video-card', VideoCard);
    Vue.component('video-card-two', VideoCardTwo);
    Vue.component('video-card-three', VideoCardThree);
    Vue.component('video-card-four', VideoCardFour);
    Vue.component('ImageText', ImageText);
    Vue.component('ColumnText', Text);
    Vue.component('Faq', Faq);
    Vue.component('faq-layout', FaqLayout);
    Vue.component('VideoBackground', VideoBanner);
    Vue.component('HeroImage', HeroImage);
    Vue.component('video-grid', VideoGrid);
    Vue.component('VideoSingle', VideoSingle);
    Vue.component('Promotions', Promotions);
    Vue.component('Category', Category);
    Vue.component('CoverCategory', CoverCategory);
    Vue.component('html-text', Html);
    Vue.component('section-title', SectionTitle);
    //Use temporary section title component
    Vue.component('block-title', BlockTitle);

    //Pages
    Vue.component('detail-movie', DetailMovie);

    Vue.component('footer-with-deco', FooterWithDeco);
    Vue.component('footer-main', FooterMain);
    Vue.component('footer-mobile', FooterMobile);
  }
}


